import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

const ContactDetails = () => {
  return (
    <Grid
      container
      spacing={2}
      margin={{ xs: "0% 0% 20% 0%", sm: "0% 0% 2% 0%" }}
      alignItems={"center"}
    >
      <Grid item xs={12} sm={12}>
        <Box marginY={4}>
          <Box
            component={"iframe"}
            borderRadius={2}
            minHeight={500}
            width="100%"
            height="100%"
            frameBorder="0"
            title="map"
            marginHeight="0"
            marginWidth="0"
            scrolling="no"
            src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=20B,%20Soetan%20Street,%20Asero%20Estate%20Asero,%20Abeokuta,%20Ogun%20State,%20Nigeria+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ContactDetails;
